export default "__VITE_ASSET__DN32HgG2__"